// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * EMRbyMD V3 — Dashboard Materialize prototype overlay.
 * Scoped to .emr-mz-dashboard so other Sandbox pages are unchanged.
 * Materialize 1.0.0 supplies grid/card/table/button/input/helper foundations.
 * These tokens and overrides win whenever Materialize defaults conflict.
 */

.emr-mz-dashboard {
  --emr-primary: #1976d2;
  --emr-primary-light: #42a5f5;
  --emr-primary-dark: #0d47a1;
  --emr-teal: #00acc1;
  --emr-success: #2e7d32;
  --emr-warning: #f9a825;
  --emr-error: #d32f2f;
  --emr-info: #0288d1;
  --emr-text: #212121;
  --emr-text-secondary: #616161;
  --emr-border: #e0e0e0;
  --emr-surface: #ffffff;
  --emr-background: #f4f7f9;
  --emr-sidebar: #0a2540;
  --emr-welcome: #e8f1fb;
  --emr-radius: 0px;
  --emr-input-height: 40px;
  --emr-control-height: 36px;
  --emr-density-gap: 12px;
  --emr-font: var(--emr-font-sans);

  font-family: var(--emr-font) !important;
  font-size: var(--emr-type-body);
  line-height: var(--emr-leading-body);
  color: var(--emr-text);
  background: var(--emr-background);
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
  min-width: 0;
  width: 100%;
  max-width: 100%;
}

.emr-mz-dashboard,
.emr-mz-dashboard *,
.emr-mz-dashboard *::before,
.emr-mz-dashboard *::after {
  font-family: inherit;
  border-radius: var(--emr-radius);
  box-sizing: border-box;
}

/* Materialize is scoped to this shell and carries normalize's form-control
   font stack, which out-specifies the \`*\` rule above and left every button,
   input and select on the browser default family. The doubled class buys the
   specificity needed to reclaim them. */
.emr-mz-dashboard.emr-mz-dashboard button,
.emr-mz-dashboard.emr-mz-dashboard input,
.emr-mz-dashboard.emr-mz-dashboard optgroup,
.emr-mz-dashboard.emr-mz-dashboard select,
.emr-mz-dashboard.emr-mz-dashboard textarea {
  font-family: var(--emr-font-sans);
}

/* \`font-family: inherit\` above would otherwise flatten deliberate monospace
   (FHIR payloads, codes) into the sans family inside the shell. */
.emr-mz-dashboard.emr-mz-dashboard code,
.emr-mz-dashboard.emr-mz-dashboard pre,
.emr-mz-dashboard.emr-mz-dashboard .font-fhir,
.emr-mz-dashboard.emr-mz-dashboard .font-mono {
  font-family: var(--emr-font-mono);
}

html:has(.emr-mz-dashboard),
body:has(.emr-mz-dashboard) {
  overflow-x: hidden;
}
.emr-mz-dashboard .rounded-full,
.emr-mz-dashboard .rounded-xl,
.emr-mz-dashboard .rounded-2xl,
.emr-mz-dashboard .rounded-md,
.emr-mz-dashboard .rounded-lg {
  border-radius: var(--emr-radius) !important;
}

/* ------------------------------------------------------------------ */
/* Materialize resets that would otherwise fight the EMR shell         */
/* ------------------------------------------------------------------ */

.emr-mz-dashboard nav {
  background: transparent;
  height: auto;
  line-height: inherit;
  box-shadow: none;
  color: inherit;
  width: auto;
}

/* Materialize default heading sizes are huge; EMRbyMD tokens win. */
.emr-mz-dashboard h1,
.emr-mz-dashboard h2,
.emr-mz-dashboard h3,
.emr-mz-dashboard h4,
.emr-mz-dashboard h5,
.emr-mz-dashboard h6 {
  margin: 0;
  line-height: 1.3;
  font-weight: 600;
  color: var(--emr-text);
}

.emr-mz-dashboard h1 {
  font-size: var(--emr-type-page-title);
}

.emr-mz-dashboard h2 {
  font-size: var(--emr-type-section-title);
}

.emr-mz-dashboard h3,
.emr-mz-dashboard h4,
.emr-mz-dashboard h5,
.emr-mz-dashboard h6 {
  font-size: var(--emr-type-card-title);
}

.emr-mz-dashboard a {
  color: inherit;
}

.emr-mz-dashboard ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.emr-mz-dashboard .row {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  margin-bottom: var(--emr-density-gap);
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  max-width: 100%;
}

.emr-mz-dashboard .row::after {
  content: none;
  display: none;
}

.emr-mz-dashboard .row .col {
  padding: 0 8px;
  float: none !important;
  box-sizing: border-box;
  min-width: 0;
}

.emr-mz-dashboard .col.s12 {
  width: 100%;
}

@media only screen and (min-width: 601px) {
  .emr-mz-dashboard .col.m5 {
    width: 41.6666666667%;
  }
  .emr-mz-dashboard .col.m6 {
    width: 50%;
  }
  .emr-mz-dashboard .col.m7 {
    width: 58.3333333333%;
  }
}

@media only screen and (min-width: 993px) {
  .emr-mz-dashboard .col.l3 {
    width: 25%;
  }
  .emr-mz-dashboard .col.l4 {
    width: 33.3333333333%;
  }
  .emr-mz-dashboard .col.l8 {
    width: 66.6666666667%;
  }
}

/* Legacy Materialize column helpers kept for other mz pages. Dashboard uses CSS grid. */
@media only screen and (min-width: 993px) and (max-width: 1439px) {
  .emr-mz-dashboard .emr-dash-quick > .col.l3 {
    width: 33.3333333333% !important;
  }
}

.emr-mz-dashboard a.card,
.emr-mz-dashboard a.emr-dash-module {
  color: inherit;
  text-decoration: none;
}

.emr-mz-dashboard .card,
.emr-mz-dashboard .card-panel {
  margin: 0 0 var(--emr-density-gap);
  border: 1px solid var(--emr-border);
  border-radius: var(--emr-radius);
  box-shadow: none;
  background: var(--emr-surface);
}

.emr-mz-dashboard .card .card-content {
  padding: 14px;
}

.emr-mz-dashboard .card .card-title {
  font-size: var(--emr-type-card-title);
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
  color: var(--emr-text);
}

.emr-mz-dashboard .card .card-action {
  padding: 0 14px 14px;
  border: 0;
}

.emr-mz-dashboard .btn,
.emr-mz-dashboard .btn-flat,
.emr-mz-dashboard .btn-large,
.emr-mz-dashboard .btn-small {
  border-radius: var(--emr-radius);
  height: var(--emr-control-height);
  line-height: var(--emr-control-height);
  font-size: var(--emr-type-button);
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  box-shadow: none;
  padding: 0 14px;
}

.emr-mz-dashboard .btn {
  background-color: var(--emr-primary);
}

.emr-mz-dashboard .btn:hover,
.emr-mz-dashboard .btn:focus {
  background-color: var(--emr-primary-dark);
  box-shadow: none;
}

.emr-mz-dashboard .btn-flat {
  color: var(--emr-primary);
  background: transparent;
}

.emr-mz-dashboard table {
  font-size: var(--emr-type-table);
}

.emr-mz-dashboard table.striped > tbody > tr:nth-child(odd) {
  background-color: #fafbfc;
}

.emr-mz-dashboard table.highlight > tbody > tr:hover {
  background-color: #f3f7fb;
}

.emr-mz-dashboard .divider {
  background-color: var(--emr-border);
  height: 1px;
}

.emr-mz-dashboard input:not([type]),
.emr-mz-dashboard input[type="text"],
.emr-mz-dashboard input[type="search"],
.emr-mz-dashboard input[type="email"],
.emr-mz-dashboard input[type="password"] {
  height: var(--emr-input-height);
  margin: 0;
  box-sizing: border-box !important;
  max-width: 100%;
  box-shadow: none;
  border: 1px solid var(--emr-border);
  border-bottom: 1px solid var(--emr-border);
  border-radius: var(--emr-radius);
  background: var(--emr-surface);
  font-size: var(--emr-type-body);
}

.emr-mz-dashboard input:not([type]):focus,
.emr-mz-dashboard input[type="text"]:focus,
.emr-mz-dashboard input[type="search"]:focus,
.emr-mz-dashboard .emr-mz-global-search:focus {
  border: 1px solid var(--emr-primary) !important;
  border-bottom: 1px solid var(--emr-primary) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;
  outline: none;
}

.emr-mz-dashboard .tabs {
  background: transparent;
  height: 38px;
  display: flex;
}

.emr-mz-dashboard .tabs .tab {
  height: 38px;
  line-height: 38px;
  text-transform: none;
  border-radius: 0;
}

.emr-mz-dashboard .tabs .tab a {
  font-size: var(--emr-type-button);
  font-weight: 600;
  color: var(--emr-text-secondary);
  border-radius: 0;
}

.emr-mz-dashboard .tabs .tab a.active,
.emr-mz-dashboard .tabs .tab a:hover {
  color: var(--emr-primary);
  background: #e3f2fd;
}

.emr-mz-dashboard .tabs .indicator {
  background-color: var(--emr-primary);
  height: 2px;
}

/* ------------------------------------------------------------------ */
/* Sidebar                                                             */
/* ------------------------------------------------------------------ */

.emr-mz-dashboard .emr-mz-sidenav,
.emr-mz-dashboard.emr-mz-sidenav,
.emr-mz-dashboard.sidebar-nav-sheet {
  width: 220px !important;
  max-width: 220px !important;
  min-width: 220px;
  overflow-x: hidden;
  background: var(--emr-sidebar) !important;
  color: #fff;
}

/* Collapsed navigation: icons only, no per-user width preference is lost —
   the choice is persisted in localStorage by AppShell. */
.emr-mz-dashboard .emr-mz-sidenav.emr-mz-sidenav--collapsed {
  width: 64px !important;
  max-width: 64px !important;
  min-width: 64px;
}

.emr-mz-dashboard .emr-mz-sidenav--collapsed .emr-mz-nav-item {
  justify-content: center;
  padding: 0;
}

.emr-mz-sidenav--collapsed .emr-mz-brand {
  flex-direction: column;
  gap: 8px;
  padding: 12px 8px;
}

.emr-mz-nav-collapse-btn {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  margin-left: auto;
  padding: 0;
  background: rgba(255, 255, 255, 0.06);
  color: #cfd8dc;
  border: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
}

.emr-mz-nav-collapse-btn:hover {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

.emr-mz-sidenav--collapsed .emr-mz-nav-collapse-btn {
  margin-left: 0;
}

/* Prefixed Materialize \`aside { display:block }\` beats Tailwind \`hidden\`. */
.emr-mz-dashboard > aside.emr-mz-sidenav {
  display: none !important;
}

@media only screen and (min-width: 1200px) {
  .emr-mz-dashboard > aside.emr-mz-sidenav {
    display: block !important;
  }
}

.emr-mz-dashboard .emr-mz-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px 12px;
}

.emr-mz-dashboard .emr-mz-brand__mark {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(25, 118, 210, 0.22);
  color: #90caf9;
  border: 1px solid rgba(66, 165, 245, 0.35);
}

.emr-mz-dashboard .emr-mz-brand__title {
  font-size: var(--emr-type-card-title);
  font-weight: 600;
  letter-spacing: 0;
  color: #fff;
  line-height: 1.2;
}

.emr-mz-dashboard .emr-mz-brand__sub {
  font-size: var(--emr-type-micro);
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #90a4ae;
  margin-top: 2px;
}

.emr-mz-dashboard .emr-mz-nav {
  padding: 4px 10px 12px;
  overflow-x: hidden;
}

.emr-mz-dashboard .emr-mz-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 38px;
  padding: 0 10px;
  margin: 1px 0;
  font-size: var(--emr-type-body);
  font-weight: 500;
  color: #cfd8dc;
  border-radius: 0 !important;
  box-shadow: none !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.emr-mz-dashboard .emr-mz-nav-item:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  color: #fff;
}

.emr-mz-dashboard .emr-mz-nav-item--active,
.emr-mz-dashboard .emr-mz-nav-item.emr-mz-nav-item--active {
  background: var(--emr-primary) !important;
  color: #fff !important;
  border-radius: 0 !important;
}

.emr-mz-dashboard .emr-mz-status {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 12px 16px 16px;
}

.emr-mz-dashboard .emr-mz-status__label {
  font-size: var(--emr-type-micro);
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #78909c;
}

.emr-mz-dashboard .emr-mz-status__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  font-size: var(--emr-type-label);
  color: #eceff1;
}

.emr-mz-dashboard .emr-mz-status__dot {
  width: 8px;
  height: 8px;
  background: #43a047;
  border-radius: 50% !important;
}

.emr-mz-dashboard .emr-mz-status__meta {
  margin-top: 8px;
  font-size: var(--emr-type-metadata);
  color: #78909c;
  line-height: 1.45;
}

/* ------------------------------------------------------------------ */
/* Header / global search                                              */
/* ------------------------------------------------------------------ */

.emr-mz-dashboard .emr-mz-header {
  background: var(--emr-surface) !important;
  border-bottom: 1px solid var(--emr-border);
  backdrop-filter: none;
  overflow-x: hidden;
}

.emr-mz-dashboard .emr-mz-header__inner {
  min-height: 56px;
  padding: 8px 20px !important;
  gap: 12px;
  min-width: 0;
  max-width: 100%;
}

.emr-mz-dashboard .emr-mz-searchform {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
}

.emr-mz-dashboard .emr-mz-global-search {
  height: var(--emr-input-height) !important;
  min-height: var(--emr-input-height) !important;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  border-radius: 0 !important;
  border: 1px solid var(--emr-border) !important;
  background: var(--emr-surface) !important;
  box-shadow: none !important;
  font-family: var(--emr-font) !important;
  font-size: var(--emr-type-body) !important;
  font-weight: 400 !important;
  padding-left: 36px !important;
  padding-right: 12px !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.emr-mz-dashboard .emr-mz-icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 0 !important;
}

@media (max-width: 1199px) {
  .emr-mz-dashboard .emr-mz-menu-btn {
    display: inline-flex !important;
  }
}

.emr-mz-dashboard .emr-mz-userchip {
  border-radius: 0 !important;
  padding: 2px 8px 2px 2px !important;
  gap: 8px;
  flex-shrink: 0;
}

.emr-mz-dashboard .emr-mz-userchip__text {
  display: none;
}

@media only screen and (min-width: 900px) {
  .emr-mz-dashboard .emr-mz-userchip__text {
    display: block;
  }
}

.emr-mz-dashboard .emr-mz-icon-btn,
.emr-mz-dashboard .emr-mz-menu-btn {
  flex-shrink: 0;
}

.emr-mz-dashboard .emr-mz-avatar,
.emr-mz-dashboard .emr-mz-avatar > span {
  width: 32px !important;
  height: 32px !important;
  border-radius: 0 !important;
  background: var(--emr-primary) !important;
  font-size: var(--emr-type-metadata);
  font-weight: 600;
}

.emr-mz-dashboard .emr-mz-userchip__name {
  font-size: var(--emr-type-label);
  font-weight: 600;
  color: var(--emr-text);
  line-height: 1.2;
}

.emr-mz-dashboard .emr-mz-userchip__role {
  font-size: var(--emr-type-metadata);
  font-weight: 400;
  color: var(--emr-text-secondary);
}

.emr-mz-dashboard .emr-mz-main {
  padding: 16px 20px 20px !important;
  min-width: 0;
  overflow-x: hidden;
}

.emr-mz-dashboard:has(.emr-dash) {
  background: #F4F7F9 !important;
}

.emr-mz-dashboard .emr-mz-main:has(.emr-dash) {
  padding: 10px 12px 12px !important;
  max-width: none;
  overflow-x: hidden;
  background: #F4F7F9 !important;
}

/* ------------------------------------------------------------------ */
/* Dashboard page                                                      */
/* ------------------------------------------------------------------ */

.emr-dash {
  max-width: none;
  margin: 0;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;
}

.emr-dash__workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  min-width: 0;
}

.emr-dash__top {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  min-width: 0;
}

.emr-dash__top-side {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-content: start;
  min-width: 0;
}

.emr-dash__lower {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-items: start;
  min-width: 0;
}

.emr-dash .card.emr-dash__section {
  margin: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  box-shadow: none;
}

.emr-dash .emr-dash__section > .card-content {
  padding: 8px 12px !important;
}

/* Signature 3px blue right edge on individual Dashboard cards only. */
.emr-dash .card.emr-dash__section:not(.emr-dash__quick-mod),
.emr-dash .card.emr-dash-module,
.emr-dash a.emr-dash-module,
.emr-dash button.emr-dash-module {
  border-right: 3px solid var(--emr-primary) !important;
  box-sizing: border-box;
}

.emr-dash__mod-title {
  margin: 0 0 4px;
  font-size: var(--emr-type-metadata) !important;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-text-secondary);
  line-height: 1.2;
}

.emr-dash__pagehead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.emr-mz-dashboard .emr-dash__title,
.emr-dash__title {
  margin: 0;
  font-size: var(--emr-type-page-title) !important;
  font-weight: 600;
  line-height: 1.25;
  color: var(--emr-text);
}

.emr-dash__subtitle {
  margin: 4px 0 0;
  font-size: var(--emr-type-helper);
  font-weight: 400;
  color: var(--emr-text-secondary);
}

.emr-dash__date {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--emr-border);
  background: var(--emr-surface);
  color: var(--emr-text);
  font-size: var(--emr-type-label);
  font-weight: 500;
  cursor: pointer;
  overflow: hidden;
}

.emr-dash__date-input {
  position: absolute;
  inset: 0;
  width: 100%;
  max-width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
  border: 0;
  background: transparent;
}

.emr-dash__date:focus-within {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18);
  border-color: var(--emr-primary);
}

.emr-dash__welcome {
  background: var(--emr-surface) !important;
  border: 1px solid var(--emr-border) !important;
  border-right: 3px solid var(--emr-primary) !important;
  margin-bottom: 0;
}

.emr-dash__welcome .card-content {
  padding: 8px 12px !important;
}

.emr-dash__welcome-body {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 16px;
  min-width: 0;
}

.emr-dash__welcome-copy {
  min-width: 0;
  flex: 1 1 200px;
}

.emr-dash__kicker {
  margin: 0;
  font-size: var(--emr-type-metadata);
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--emr-primary);
}

.emr-mz-dashboard .emr-dash__name,
.emr-dash__name {
  margin: 2px 0 0;
  font-size: var(--emr-type-section-title) !important;
  font-weight: 600;
  line-height: 1.25;
  color: var(--emr-text);
}

.emr-dash__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  margin-top: 4px;
  font-size: var(--emr-type-helper);
  color: var(--emr-text-secondary);
}

.emr-dash__role {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 6px;
  background: #d6e9fa;
  color: var(--emr-primary-dark);
  font-size: var(--emr-type-metadata);
  font-weight: 600;
}

.emr-dash__orgrow {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin-top: 6px;
  font-size: var(--emr-type-helper);
  color: var(--emr-text);
}

.emr-dash__orgrow span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.emr-dash__welcome-aside {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 2px;
  min-height: 0;
  text-align: right;
  flex: 0 1 150px;
}

.emr-dash__pulse {
  width: 96px;
  height: 28px;
  display: block;
}

.emr-dash__quote {
  margin: 0;
  max-width: 160px;
  font-size: var(--emr-type-metadata);
  font-style: italic;
  color: var(--emr-primary-dark);
  line-height: 1.3;
}

.emr-mz-dashboard .emr-dash__section-title,
.emr-dash__section-title {
  margin: 0 0 4px;
  font-size: var(--emr-type-section-title) !important;
  font-weight: 600;
  color: var(--emr-text);
}

.emr-dash__section-help {
  margin: 0 0 6px;
  font-size: var(--emr-type-helper);
  color: var(--emr-text-secondary);
}

.emr-dash-quick {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  align-items: stretch;
  min-width: 0;
}

.emr-dash-quick > .emr-dash-module,
.emr-dash-quick > a.emr-dash-module,
.emr-dash-quick > button.emr-dash-module {
  margin: 0 !important;
  min-width: 0;
  width: 100%;
}

@media only screen and (min-width: 600px) {
  .emr-dash-quick {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .emr-dash__top-side {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

@media only screen and (min-width: 1024px) {
  .emr-dash__top {
    grid-template-columns: minmax(0, 1.45fr) minmax(210px, 1fr) minmax(210px, 1fr);
    align-items: stretch;
  }

  .emr-dash__top-side {
    display: contents;
  }

  .emr-dash__welcome-body {
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px 16px;
  }

  .emr-dash__lower {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    align-items: start;
  }

  .emr-dash-quick {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media only screen and (min-width: 1280px) {
  .emr-dash-quick {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

button.emr-dash-module {
  width: 100%;
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: inherit;
  background: var(--emr-surface);
}

.emr-dash-module:focus-visible,
.emr-dash__date:focus-within,
.emr-mz-dashboard .emr-mz-nav-item:focus-visible,
.emr-mz-dashboard .emr-mz-userchip:focus-visible,
.emr-mz-dashboard .emr-mz-icon-btn:focus-visible,
.emr-mz-dashboard .emr-mz-global-search:focus-visible {
  outline: 2px solid var(--emr-primary);
  outline-offset: 2px;
}

.emr-dash-module {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 100%;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.emr-dash-module:hover {
  border-top-color: var(--emr-primary-light);
  border-left-color: var(--emr-primary-light);
  border-bottom-color: var(--emr-primary-light);
  border-right-color: var(--emr-primary);
}

.emr-dash-module:focus {
  outline: none;
}

.emr-dash-module .card-content {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  grid-template-areas:
    "icon title"
    "icon desc"
    "icon action";
  column-gap: 10px;
  row-gap: 2px;
  align-content: start;
  flex: 0 0 auto;
  padding: 8px 10px !important;
}

.emr-dash-module__icon {
  grid-area: icon;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3f2fd;
  color: var(--emr-primary);
  margin-bottom: 0;
  align-self: start;
}

.emr-dash-module .card-title {
  grid-area: title;
  font-size: var(--emr-type-card-title) !important;
  font-weight: 600 !important;
  line-height: 1.25;
}

.emr-dash-module p {
  grid-area: desc;
  margin: 0;
  flex: none;
  font-size: var(--emr-type-helper);
  line-height: 1.35;
  color: var(--emr-text-secondary);
}

.emr-dash-module__action {
  grid-area: action;
  font-size: var(--emr-type-label);
  font-weight: 600;
  color: var(--emr-primary);
  margin-top: 2px;
}

.emr-dash-panel .card-content {
  padding: 8px 12px !important;
}

.emr-dash-panel__head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.emr-dash-panel__icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3f2fd;
  color: var(--emr-primary);
}

.emr-dash-panel__list a,
.emr-dash-panel__list .emr-dash-panel__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 28px;
  padding: 2px 0;
  font-size: var(--emr-type-body);
  color: var(--emr-text);
  border-bottom: 1px solid #f0f0f0;
}

.emr-dash-panel__list a:hover {
  color: var(--emr-primary);
}

.emr-dash-panel__list a:last-child,
.emr-dash-panel__list .emr-dash-panel__row:last-child {
  border-bottom: 0;
}

.emr-dash-panel__avail {
  font-size: var(--emr-type-helper);
  font-weight: 600;
  color: var(--emr-primary);
}

.emr-dash-planned {
  border: 1px solid #eeeeee;
  background: #fafafa;
  padding: 6px 10px;
  margin-bottom: 6px;
}

.emr-dash-planned__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: var(--emr-type-label);
  font-weight: 600;
}

.emr-dash-planned p {
  margin: 4px 0 0;
  font-size: var(--emr-type-helper);
  color: var(--emr-text-secondary);
}

.emr-dash-glance__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 28px;
  padding: 2px 0;
  border-bottom: 1px solid #f0f0f0;
  color: var(--emr-text);
}

.emr-dash-glance__row:last-child {
  border-bottom: 0;
}

.emr-dash-glance__label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: var(--emr-type-body);
}

.emr-dash-glance__icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.emr-dash-glance__icon--patients {
  background: #e3f2fd;
  color: var(--emr-primary);
}
.emr-dash-glance__icon--encounters {
  background: #e8f5e9;
  color: var(--emr-success);
}
.emr-dash-glance__icon--worklists {
  background: #f3e5f5;
  color: #7b1fa2;
}
.emr-dash-glance__icon--alerts {
  background: #ffebee;
  color: var(--emr-error);
}

.emr-dash-glance__value {
  font-size: var(--emr-type-section-title);
  font-weight: 600;
  color: var(--emr-text);
  white-space: nowrap;
}

.emr-dash-glance__value.is-empty {
  color: #9e9e9e;
}

.emr-dash-activity-wrap {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.emr-mz-dashboard table.emr-dash-activity,
.emr-dash-activity {
  display: table;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  border-collapse: collapse;
  position: static;
}

.emr-mz-dashboard table.emr-dash-activity thead,
.emr-mz-dashboard table.emr-dash-activity tbody {
  display: table-header-group;
  float: none;
  width: auto;
  position: static;
  overflow: visible;
  white-space: normal;
}

.emr-mz-dashboard table.emr-dash-activity tbody {
  display: table-row-group;
}

.emr-dash-activity th {
  font-size: var(--emr-type-table-head);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-text-secondary);
  padding: 2px 8px 4px 0;
}

.emr-dash-activity td {
  font-size: var(--emr-type-table);
  padding: 6px 8px 6px 0;
  color: var(--emr-text-secondary);
}

.emr-dash-empty {
  text-align: center;
  color: var(--emr-text-secondary);
}

.emr-dash__footer.card-panel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 0;
  padding: 10px 12px;
  font-size: var(--emr-type-metadata);
  color: var(--emr-text-secondary);
}

.emr-dash__footer-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.emr-mz-dashboard .btn.emr-dash-btn-block {
  display: block;
  width: 100%;
  text-align: center;
  margin-top: 6px;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
}

.emr-mz-dashboard .btn-flat.emr-dash-btn-block {
  border: 1px solid #bbdefb;
  color: var(--emr-primary-dark);
}

.emr-mz-dashboard .btn-flat.emr-dash-btn-block:hover {
  background: #e3f2fd;
}

@media only screen and (max-width: 992px) {
  .emr-dash__welcome-aside {
    align-items: flex-start;
    text-align: left;
  }

  .emr-mz-dashboard .emr-mz-main {
    padding: 12px 16px 16px !important;
  }

  .emr-mz-dashboard .emr-mz-header__inner {
    padding: 8px 16px !important;
  }

  .emr-dash-glance {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 8px;
  }

  .emr-dash-glance__row {
    min-width: 0;
    padding: 3px 4px;
  }

  .emr-dash-glance__label {
    min-width: 0;
  }

  .emr-dash-glance__value {
    flex-shrink: 0;
  }

  .emr-dash__footer.card-panel {
    padding: 10px 12px;
  }
}

/* Large phone (~430px): 2-column Quick Access if cards stay readable. */
@media only screen and (min-width: 400px) and (max-width: 600px) {
  .emr-dash-quick {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media only screen and (max-width: 600px) {
  .emr-mz-dashboard {
    font-size: var(--emr-type-body);
  }

  .emr-mz-dashboard .emr-mz-header__inner {
    padding: 8px 12px !important;
    gap: 8px;
  }

  .emr-mz-dashboard .emr-mz-main {
    padding: 12px !important;
  }

  .emr-mz-dashboard .emr-dash__title,
  .emr-dash__title {
    font-size: var(--emr-type-page-title-compact) !important;
  }

  .emr-mz-dashboard .row .col {
    padding: 0 6px;
  }

  .emr-mz-dashboard .card .card-content,
  .emr-dash-panel .card-content {
    padding: 8px 10px !important;
  }

  .emr-dash-module .card-content {
    padding: 8px 10px !important;
  }

  .emr-dash-module {
    height: auto;
    min-height: 0;
  }

  .emr-dash__pagehead {
    margin-bottom: 10px;
    gap: 8px;
  }

  .emr-dash__date {
    flex-shrink: 0;
    padding: 0 8px;
    font-size: var(--emr-type-helper);
  }

  .emr-dash__name,
  .emr-dash__meta,
  .emr-dash__orgrow {
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .emr-dash-module__icon,
  .emr-dash-panel__icon {
    width: 24px;
    height: 24px;
  }

  .emr-mz-dashboard .emr-mz-global-search::placeholder {
    font-size: var(--emr-type-label);
  }
}

@media only screen and (max-width: 899px) {
  .emr-mz-dashboard .emr-mz-userchip__chevron {
    display: none !important;
  }
}

/* iPhone-width header: search is a full-width rectangle under compact controls. */
@media only screen and (max-width: 430px) {
  .emr-mz-dashboard .emr-mz-header__inner {
    flex-wrap: wrap;
    padding: 8px 12px 10px !important;
  }

  .emr-mz-dashboard .emr-mz-searchform {
    order: 5;
    flex: 1 1 100%;
    width: 100%;
    max-width: 100%;
  }

  .emr-mz-dashboard .emr-mz-global-search {
    width: 100% !important;
  }

  .emr-dash__pagehead {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .emr-dash__date {
    margin-top: 2px;
  }

  .emr-dash-glance__label {
    font-size: var(--emr-type-label);
    gap: 6px;
  }
}

/* Small phone: prefer a single Quick Access / glance column. */
@media only screen and (max-width: 399px) {
  .emr-mz-dashboard .emr-dash-quick > .col.s12 {
    width: 100% !important;
  }

  .emr-dash-glance {
    grid-template-columns: 1fr;
  }

  .emr-dash__date span {
    max-width: 9.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* ------------------------------------------------------------------ */
/* Patients list — same tokens as Dashboard, page-specific layout only */
/* ------------------------------------------------------------------ */

.emr-pat {
  max-width: none;
  margin: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.emr-pat__pagehead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.emr-mz-dashboard .emr-pat__title,
.emr-pat__title {
  margin: 0;
  font-size: var(--emr-type-page-title) !important;
  font-weight: 600;
  line-height: 1.25;
  color: var(--emr-text);
}

.emr-pat__subtitle {
  margin: 2px 0 0;
  font-size: var(--emr-type-helper);
  font-weight: 400;
  color: var(--emr-text-secondary);
}

.emr-mz-dashboard .btn.emr-pat__register {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: var(--emr-control-height);
  padding: 0 14px;
  margin: 0;
  flex-shrink: 0;
  background: var(--emr-primary);
  border-radius: 0;
}

.emr-mz-dashboard .btn.emr-pat__register:hover,
.emr-mz-dashboard .btn.emr-pat__register:focus {
  background: var(--emr-primary-dark);
}

.emr-pat__register-icon {
  width: 16px;
  height: 16px;
}

.emr-pat__search {
  position: relative;
  max-width: 420px;
  width: 100%;
  min-width: 0;
  margin-bottom: 6px;
}

.emr-pat__search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  width: 16px;
  height: 16px;
  transform: translateY(-50%);
  color: var(--emr-text-secondary);
  pointer-events: none;
  z-index: 1;
}

.emr-mz-dashboard .emr-pat__search-input,
.emr-pat__search-input {
  height: var(--emr-input-height) !important;
  min-height: var(--emr-input-height) !important;
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box !important;
  padding-left: 36px !important;
  padding-right: 12px !important;
  border: 1px solid var(--emr-border) !important;
  border-radius: 0 !important;
  background: var(--emr-surface) !important;
  box-shadow: none !important;
  font-size: var(--emr-type-body) !important;
  font-weight: 400 !important;
}

.emr-mz-dashboard .emr-pat__search-input:focus {
  border: 1px solid var(--emr-primary) !important;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;
  outline: none;
}

.emr-pat__panel {
  margin-bottom: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
}

.emr-pat__status,
.emr-pat__empty {
  padding: 28px 16px;
  text-align: center;
  font-size: var(--emr-type-body);
  color: var(--emr-text-secondary);
}

.emr-pat__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.emr-pat__empty-icon {
  width: 32px;
  height: 32px;
  color: #bdbdbd;
}

.emr-pat__table-wrap {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

/* Keep a real table (not Materialize's split-header responsive-table) so
   phones scroll inside this wrapper instead of fracturing the page. */
.emr-mz-dashboard table.emr-pat__table,
.emr-pat__table {
  display: table;
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
  position: static;
}

.emr-mz-dashboard table.emr-pat__table thead,
.emr-mz-dashboard table.emr-pat__table tbody {
  display: table-header-group;
  position: static;
  float: none;
  overflow: visible;
  width: auto;
}

.emr-mz-dashboard table.emr-pat__table tbody {
  display: table-row-group;
}

.emr-mz-dashboard table.emr-pat__table tr {
  display: table-row;
}

.emr-mz-dashboard table.emr-pat__table th,
.emr-mz-dashboard table.emr-pat__table td {
  display: table-cell;
  padding-top: 4px;
  padding-bottom: 4px;
  line-height: 1.25;
}

.emr-mz-dashboard .emr-pat__table th {
  font-size: var(--emr-type-table-head);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--emr-text-secondary);
  padding: 4px 12px;
  line-height: 1.25;
  border-bottom: 1px solid var(--emr-border);
  background: #fafbfc;
  white-space: nowrap;
}

.emr-mz-dashboard .emr-pat__table td {
  font-size: var(--emr-type-table);
  font-weight: 400;
  padding: 4px 12px;
  line-height: var(--emr-leading-compact);
  color: var(--emr-text);
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}

.emr-pat__actions-col {
  text-align: right;
}

.emr-pat__mrn {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  background: #0b1f33;
  color: #90caf9;
  font-size: var(--emr-type-metadata);
  font-weight: 600;
  letter-spacing: 0.02em;
  text-decoration: none;
  border-radius: 0;
}

.emr-pat__mrn:hover {
  background: var(--emr-primary-dark);
  color: #fff;
}

.emr-pat__name {
  font-size: var(--emr-type-table);
  font-weight: 600;
  color: var(--emr-text);
  text-decoration: none;
}

.emr-pat__name:hover {
  color: var(--emr-primary);
  text-decoration: underline;
}

.emr-pat__demo {
  display: inline-flex;
  align-items: center;
  height: 18px;
  margin-left: 8px;
  padding: 0 6px;
  background: #fff8e1;
  color: #f9a825;
  font-size: var(--emr-type-micro);
  font-weight: 700;
  letter-spacing: 0.06em;
  vertical-align: middle;
  border-radius: 0;
}

.emr-pat__row-actions {
  display: flex;
  justify-content: flex-end;
  gap: 2px;
}

.emr-mz-dashboard .emr-pat-icon-btn {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  min-height: 24px !important;
  padding: 0 !important;
  line-height: 1 !important;
  border-radius: 0 !important;
  color: var(--emr-primary);
}

.emr-mz-dashboard .emr-pat-icon-btn--danger {
  color: var(--emr-error);
}

.emr-pat-form,
.emr-pat-dialog {
  border-radius: 0 !important;
  border: 1px solid var(--emr-border, #e0e0e0);
  background: #fff !important;
  box-shadow: none;
}

.emr-pat-form [data-radix-collection-item],
.emr-pat-form [role="tab"] {
  border-radius: 0 !important;
  font-size: var(--emr-type-button);
  font-weight: 600;
}

.emr-mz-dashboard .emr-pat-form__save,
.emr-pat-form .emr-pat-form__save {
  background: #1976d2 !important;
  border-radius: 0 !important;
  font-size: var(--emr-type-button);
  font-weight: 600;
}

.emr-mz-dashboard .emr-pat-form__save:hover,
.emr-pat-form .emr-pat-form__save:hover {
  background: #0d47a1 !important;
}

.emr-pat-dialog__delete {
  background: #d32f2f !important;
  border-radius: 0 !important;
}

@media only screen and (max-width: 899px) {
  .emr-pat__pagehead {
    flex-wrap: wrap;
  }
}

@media only screen and (max-width: 600px) {
  .emr-pat__pagehead {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    margin-bottom: 6px;
  }

  .emr-mz-dashboard .emr-pat__title,
  .emr-pat__title {
    font-size: var(--emr-type-page-title-compact) !important;
  }

  .emr-mz-dashboard .btn.emr-pat__register {
    width: 100%;
    justify-content: center;
  }

  .emr-pat__search {
    max-width: 100%;
  }

  .emr-mz-dashboard .emr-pat__table th,
  .emr-mz-dashboard .emr-pat__table td {
    padding: 4px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-dashboard.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,gCAAgC;;EAEhC,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;EACjC,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;;;;EAIE,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;wCAGwC;AACxC;;;;;EAKE,iCAAiC;AACnC;;AAEA;kEACkE;AAClE;;;;EAIE,iCAAiC;AACnC;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;;;;EAKE,2CAA2C;AAC7C;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA,oEAAoE;AACpE;;;;;;EAME,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;;EAIE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA,wFAAwF;AACxF;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;;;;EAIE,gCAAgC;EAChC,iCAAiC;EACjC,sCAAsC;EACtC,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;;;;;EAKE,+BAA+B;EAC/B,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,0CAA0C;EAC1C,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;;;EAIE,+CAA+C;EAC/C,sDAAsD;EACtD,yDAAyD;EACzD,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;AACb;;AAEA;yDACyD;AACzD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,qCAAqC;EACrC,cAAc;EACd,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,WAAW;AACb;;AAEA;;EAEE,yCAAyC;EACzC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,cAAc;EACd,iBAAiB;AACnB;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,8CAA8C;EAC9C,yCAAyC;EACzC,2BAA2B;EAC3B,uCAAuC;EACvC,0CAA0C;EAC1C,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sEAAsE;AACtE;;;;EAIE,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,UAAU;EACV,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,8CAA8C;EAC9C,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,mDAAmD;EACnD,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,mDAAmD;EACnD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,oBAAoB;EACpB,YAAY;AACd;;AAEA;;;EAGE,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,8EAA8E;IAC9E,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,oDAAoD;IACpD,kBAAkB;EACpB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;EACd,8BAA8B;AAChC;;AAEA;;;;;;EAME,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C;;;iBAGe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;IAC5B,QAAQ;EACV;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,wDAAwD;EAC1D;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,cAAc;IACd,iCAAiC;EACnC;;EAEA;;;IAGE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,kFAAkF;AAClF;EACE;IACE,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,QAAQ;IACR,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gCAAgC;IAChC,QAAQ;EACV;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,eAAe;EACf,SAAS;EACT,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;EAEE,0CAA0C;EAC1C,8CAA8C;EAC9C,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;EAC9C,2BAA2B;EAC3B,yCAAyC;EACzC,2BAA2B;EAC3B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,yDAAyD;EACzD,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;sEACsE;AACtE;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,4CAA4C;EAC5C,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;;IAEE,wDAAwD;EAC1D;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":["/*\n * EMRbyMD V3 — Dashboard Materialize prototype overlay.\n * Scoped to .emr-mz-dashboard so other Sandbox pages are unchanged.\n * Materialize 1.0.0 supplies grid/card/table/button/input/helper foundations.\n * These tokens and overrides win whenever Materialize defaults conflict.\n */\n\n.emr-mz-dashboard {\n  --emr-primary: #1976d2;\n  --emr-primary-light: #42a5f5;\n  --emr-primary-dark: #0d47a1;\n  --emr-teal: #00acc1;\n  --emr-success: #2e7d32;\n  --emr-warning: #f9a825;\n  --emr-error: #d32f2f;\n  --emr-info: #0288d1;\n  --emr-text: #212121;\n  --emr-text-secondary: #616161;\n  --emr-border: #e0e0e0;\n  --emr-surface: #ffffff;\n  --emr-background: #f4f7f9;\n  --emr-sidebar: #0a2540;\n  --emr-welcome: #e8f1fb;\n  --emr-radius: 0px;\n  --emr-input-height: 40px;\n  --emr-control-height: 36px;\n  --emr-density-gap: 12px;\n  --emr-font: var(--emr-font-sans);\n\n  font-family: var(--emr-font) !important;\n  font-size: var(--emr-type-body);\n  line-height: var(--emr-leading-body);\n  color: var(--emr-text);\n  background: var(--emr-background);\n  -webkit-font-smoothing: antialiased;\n  overflow-x: hidden;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.emr-mz-dashboard,\n.emr-mz-dashboard *,\n.emr-mz-dashboard *::before,\n.emr-mz-dashboard *::after {\n  font-family: inherit;\n  border-radius: var(--emr-radius);\n  box-sizing: border-box;\n}\n\n/* Materialize is scoped to this shell and carries normalize's form-control\n   font stack, which out-specifies the `*` rule above and left every button,\n   input and select on the browser default family. The doubled class buys the\n   specificity needed to reclaim them. */\n.emr-mz-dashboard.emr-mz-dashboard button,\n.emr-mz-dashboard.emr-mz-dashboard input,\n.emr-mz-dashboard.emr-mz-dashboard optgroup,\n.emr-mz-dashboard.emr-mz-dashboard select,\n.emr-mz-dashboard.emr-mz-dashboard textarea {\n  font-family: var(--emr-font-sans);\n}\n\n/* `font-family: inherit` above would otherwise flatten deliberate monospace\n   (FHIR payloads, codes) into the sans family inside the shell. */\n.emr-mz-dashboard.emr-mz-dashboard code,\n.emr-mz-dashboard.emr-mz-dashboard pre,\n.emr-mz-dashboard.emr-mz-dashboard .font-fhir,\n.emr-mz-dashboard.emr-mz-dashboard .font-mono {\n  font-family: var(--emr-font-mono);\n}\n\nhtml:has(.emr-mz-dashboard),\nbody:has(.emr-mz-dashboard) {\n  overflow-x: hidden;\n}\n.emr-mz-dashboard .rounded-full,\n.emr-mz-dashboard .rounded-xl,\n.emr-mz-dashboard .rounded-2xl,\n.emr-mz-dashboard .rounded-md,\n.emr-mz-dashboard .rounded-lg {\n  border-radius: var(--emr-radius) !important;\n}\n\n/* ------------------------------------------------------------------ */\n/* Materialize resets that would otherwise fight the EMR shell         */\n/* ------------------------------------------------------------------ */\n\n.emr-mz-dashboard nav {\n  background: transparent;\n  height: auto;\n  line-height: inherit;\n  box-shadow: none;\n  color: inherit;\n  width: auto;\n}\n\n/* Materialize default heading sizes are huge; EMRbyMD tokens win. */\n.emr-mz-dashboard h1,\n.emr-mz-dashboard h2,\n.emr-mz-dashboard h3,\n.emr-mz-dashboard h4,\n.emr-mz-dashboard h5,\n.emr-mz-dashboard h6 {\n  margin: 0;\n  line-height: 1.3;\n  font-weight: 600;\n  color: var(--emr-text);\n}\n\n.emr-mz-dashboard h1 {\n  font-size: var(--emr-type-page-title);\n}\n\n.emr-mz-dashboard h2 {\n  font-size: var(--emr-type-section-title);\n}\n\n.emr-mz-dashboard h3,\n.emr-mz-dashboard h4,\n.emr-mz-dashboard h5,\n.emr-mz-dashboard h6 {\n  font-size: var(--emr-type-card-title);\n}\n\n.emr-mz-dashboard a {\n  color: inherit;\n}\n\n.emr-mz-dashboard ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.emr-mz-dashboard .row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  margin-bottom: var(--emr-density-gap);\n  margin-left: 0;\n  margin-right: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.emr-mz-dashboard .row::after {\n  content: none;\n  display: none;\n}\n\n.emr-mz-dashboard .row .col {\n  padding: 0 8px;\n  float: none !important;\n  box-sizing: border-box;\n  min-width: 0;\n}\n\n.emr-mz-dashboard .col.s12 {\n  width: 100%;\n}\n\n@media only screen and (min-width: 601px) {\n  .emr-mz-dashboard .col.m5 {\n    width: 41.6666666667%;\n  }\n  .emr-mz-dashboard .col.m6 {\n    width: 50%;\n  }\n  .emr-mz-dashboard .col.m7 {\n    width: 58.3333333333%;\n  }\n}\n\n@media only screen and (min-width: 993px) {\n  .emr-mz-dashboard .col.l3 {\n    width: 25%;\n  }\n  .emr-mz-dashboard .col.l4 {\n    width: 33.3333333333%;\n  }\n  .emr-mz-dashboard .col.l8 {\n    width: 66.6666666667%;\n  }\n}\n\n/* Legacy Materialize column helpers kept for other mz pages. Dashboard uses CSS grid. */\n@media only screen and (min-width: 993px) and (max-width: 1439px) {\n  .emr-mz-dashboard .emr-dash-quick > .col.l3 {\n    width: 33.3333333333% !important;\n  }\n}\n\n.emr-mz-dashboard a.card,\n.emr-mz-dashboard a.emr-dash-module {\n  color: inherit;\n  text-decoration: none;\n}\n\n.emr-mz-dashboard .card,\n.emr-mz-dashboard .card-panel {\n  margin: 0 0 var(--emr-density-gap);\n  border: 1px solid var(--emr-border);\n  border-radius: var(--emr-radius);\n  box-shadow: none;\n  background: var(--emr-surface);\n}\n\n.emr-mz-dashboard .card .card-content {\n  padding: 14px;\n}\n\n.emr-mz-dashboard .card .card-title {\n  font-size: var(--emr-type-card-title);\n  font-weight: 600;\n  line-height: 1.3;\n  margin: 0;\n  color: var(--emr-text);\n}\n\n.emr-mz-dashboard .card .card-action {\n  padding: 0 14px 14px;\n  border: 0;\n}\n\n.emr-mz-dashboard .btn,\n.emr-mz-dashboard .btn-flat,\n.emr-mz-dashboard .btn-large,\n.emr-mz-dashboard .btn-small {\n  border-radius: var(--emr-radius);\n  height: var(--emr-control-height);\n  line-height: var(--emr-control-height);\n  font-size: var(--emr-type-button);\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  box-shadow: none;\n  padding: 0 14px;\n}\n\n.emr-mz-dashboard .btn {\n  background-color: var(--emr-primary);\n}\n\n.emr-mz-dashboard .btn:hover,\n.emr-mz-dashboard .btn:focus {\n  background-color: var(--emr-primary-dark);\n  box-shadow: none;\n}\n\n.emr-mz-dashboard .btn-flat {\n  color: var(--emr-primary);\n  background: transparent;\n}\n\n.emr-mz-dashboard table {\n  font-size: var(--emr-type-table);\n}\n\n.emr-mz-dashboard table.striped > tbody > tr:nth-child(odd) {\n  background-color: #fafbfc;\n}\n\n.emr-mz-dashboard table.highlight > tbody > tr:hover {\n  background-color: #f3f7fb;\n}\n\n.emr-mz-dashboard .divider {\n  background-color: var(--emr-border);\n  height: 1px;\n}\n\n.emr-mz-dashboard input:not([type]),\n.emr-mz-dashboard input[type=\"text\"],\n.emr-mz-dashboard input[type=\"search\"],\n.emr-mz-dashboard input[type=\"email\"],\n.emr-mz-dashboard input[type=\"password\"] {\n  height: var(--emr-input-height);\n  margin: 0;\n  box-sizing: border-box !important;\n  max-width: 100%;\n  box-shadow: none;\n  border: 1px solid var(--emr-border);\n  border-bottom: 1px solid var(--emr-border);\n  border-radius: var(--emr-radius);\n  background: var(--emr-surface);\n  font-size: var(--emr-type-body);\n}\n\n.emr-mz-dashboard input:not([type]):focus,\n.emr-mz-dashboard input[type=\"text\"]:focus,\n.emr-mz-dashboard input[type=\"search\"]:focus,\n.emr-mz-dashboard .emr-mz-global-search:focus {\n  border: 1px solid var(--emr-primary) !important;\n  border-bottom: 1px solid var(--emr-primary) !important;\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;\n  outline: none;\n}\n\n.emr-mz-dashboard .tabs {\n  background: transparent;\n  height: 38px;\n  display: flex;\n}\n\n.emr-mz-dashboard .tabs .tab {\n  height: 38px;\n  line-height: 38px;\n  text-transform: none;\n  border-radius: 0;\n}\n\n.emr-mz-dashboard .tabs .tab a {\n  font-size: var(--emr-type-button);\n  font-weight: 600;\n  color: var(--emr-text-secondary);\n  border-radius: 0;\n}\n\n.emr-mz-dashboard .tabs .tab a.active,\n.emr-mz-dashboard .tabs .tab a:hover {\n  color: var(--emr-primary);\n  background: #e3f2fd;\n}\n\n.emr-mz-dashboard .tabs .indicator {\n  background-color: var(--emr-primary);\n  height: 2px;\n}\n\n/* ------------------------------------------------------------------ */\n/* Sidebar                                                             */\n/* ------------------------------------------------------------------ */\n\n.emr-mz-dashboard .emr-mz-sidenav,\n.emr-mz-dashboard.emr-mz-sidenav,\n.emr-mz-dashboard.sidebar-nav-sheet {\n  width: 220px !important;\n  max-width: 220px !important;\n  min-width: 220px;\n  overflow-x: hidden;\n  background: var(--emr-sidebar) !important;\n  color: #fff;\n}\n\n/* Collapsed navigation: icons only, no per-user width preference is lost —\n   the choice is persisted in localStorage by AppShell. */\n.emr-mz-dashboard .emr-mz-sidenav.emr-mz-sidenav--collapsed {\n  width: 64px !important;\n  max-width: 64px !important;\n  min-width: 64px;\n}\n\n.emr-mz-dashboard .emr-mz-sidenav--collapsed .emr-mz-nav-item {\n  justify-content: center;\n  padding: 0;\n}\n\n.emr-mz-sidenav--collapsed .emr-mz-brand {\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 8px;\n}\n\n.emr-mz-nav-collapse-btn {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n  margin-left: auto;\n  padding: 0;\n  background: rgba(255, 255, 255, 0.06);\n  color: #cfd8dc;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  cursor: pointer;\n}\n\n.emr-mz-nav-collapse-btn:hover {\n  background: rgba(255, 255, 255, 0.14);\n  color: #fff;\n}\n\n.emr-mz-sidenav--collapsed .emr-mz-nav-collapse-btn {\n  margin-left: 0;\n}\n\n/* Prefixed Materialize `aside { display:block }` beats Tailwind `hidden`. */\n.emr-mz-dashboard > aside.emr-mz-sidenav {\n  display: none !important;\n}\n\n@media only screen and (min-width: 1200px) {\n  .emr-mz-dashboard > aside.emr-mz-sidenav {\n    display: block !important;\n  }\n}\n\n.emr-mz-dashboard .emr-mz-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px 12px;\n}\n\n.emr-mz-dashboard .emr-mz-brand__mark {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(25, 118, 210, 0.22);\n  color: #90caf9;\n  border: 1px solid rgba(66, 165, 245, 0.35);\n}\n\n.emr-mz-dashboard .emr-mz-brand__title {\n  font-size: var(--emr-type-card-title);\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #fff;\n  line-height: 1.2;\n}\n\n.emr-mz-dashboard .emr-mz-brand__sub {\n  font-size: var(--emr-type-micro);\n  font-weight: 500;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #90a4ae;\n  margin-top: 2px;\n}\n\n.emr-mz-dashboard .emr-mz-nav {\n  padding: 4px 10px 12px;\n  overflow-x: hidden;\n}\n\n.emr-mz-dashboard .emr-mz-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 38px;\n  padding: 0 10px;\n  margin: 1px 0;\n  font-size: var(--emr-type-body);\n  font-weight: 500;\n  color: #cfd8dc;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.emr-mz-dashboard .emr-mz-nav-item:hover {\n  background: rgba(255, 255, 255, 0.06) !important;\n  color: #fff;\n}\n\n.emr-mz-dashboard .emr-mz-nav-item--active,\n.emr-mz-dashboard .emr-mz-nav-item.emr-mz-nav-item--active {\n  background: var(--emr-primary) !important;\n  color: #fff !important;\n  border-radius: 0 !important;\n}\n\n.emr-mz-dashboard .emr-mz-status {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 12px 16px 16px;\n}\n\n.emr-mz-dashboard .emr-mz-status__label {\n  font-size: var(--emr-type-micro);\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #78909c;\n}\n\n.emr-mz-dashboard .emr-mz-status__row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  font-size: var(--emr-type-label);\n  color: #eceff1;\n}\n\n.emr-mz-dashboard .emr-mz-status__dot {\n  width: 8px;\n  height: 8px;\n  background: #43a047;\n  border-radius: 50% !important;\n}\n\n.emr-mz-dashboard .emr-mz-status__meta {\n  margin-top: 8px;\n  font-size: var(--emr-type-metadata);\n  color: #78909c;\n  line-height: 1.45;\n}\n\n/* ------------------------------------------------------------------ */\n/* Header / global search                                              */\n/* ------------------------------------------------------------------ */\n\n.emr-mz-dashboard .emr-mz-header {\n  background: var(--emr-surface) !important;\n  border-bottom: 1px solid var(--emr-border);\n  backdrop-filter: none;\n  overflow-x: hidden;\n}\n\n.emr-mz-dashboard .emr-mz-header__inner {\n  min-height: 56px;\n  padding: 8px 20px !important;\n  gap: 12px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.emr-mz-dashboard .emr-mz-searchform {\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.emr-mz-dashboard .emr-mz-global-search {\n  height: var(--emr-input-height) !important;\n  min-height: var(--emr-input-height) !important;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  border-radius: 0 !important;\n  border: 1px solid var(--emr-border) !important;\n  background: var(--emr-surface) !important;\n  box-shadow: none !important;\n  font-family: var(--emr-font) !important;\n  font-size: var(--emr-type-body) !important;\n  font-weight: 400 !important;\n  padding-left: 36px !important;\n  padding-right: 12px !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.emr-mz-dashboard .emr-mz-icon-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 0 !important;\n}\n\n@media (max-width: 1199px) {\n  .emr-mz-dashboard .emr-mz-menu-btn {\n    display: inline-flex !important;\n  }\n}\n\n.emr-mz-dashboard .emr-mz-userchip {\n  border-radius: 0 !important;\n  padding: 2px 8px 2px 2px !important;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.emr-mz-dashboard .emr-mz-userchip__text {\n  display: none;\n}\n\n@media only screen and (min-width: 900px) {\n  .emr-mz-dashboard .emr-mz-userchip__text {\n    display: block;\n  }\n}\n\n.emr-mz-dashboard .emr-mz-icon-btn,\n.emr-mz-dashboard .emr-mz-menu-btn {\n  flex-shrink: 0;\n}\n\n.emr-mz-dashboard .emr-mz-avatar,\n.emr-mz-dashboard .emr-mz-avatar > span {\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 0 !important;\n  background: var(--emr-primary) !important;\n  font-size: var(--emr-type-metadata);\n  font-weight: 600;\n}\n\n.emr-mz-dashboard .emr-mz-userchip__name {\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  color: var(--emr-text);\n  line-height: 1.2;\n}\n\n.emr-mz-dashboard .emr-mz-userchip__role {\n  font-size: var(--emr-type-metadata);\n  font-weight: 400;\n  color: var(--emr-text-secondary);\n}\n\n.emr-mz-dashboard .emr-mz-main {\n  padding: 16px 20px 20px !important;\n  min-width: 0;\n  overflow-x: hidden;\n}\n\n.emr-mz-dashboard:has(.emr-dash) {\n  background: #F4F7F9 !important;\n}\n\n.emr-mz-dashboard .emr-mz-main:has(.emr-dash) {\n  padding: 10px 12px 12px !important;\n  max-width: none;\n  overflow-x: hidden;\n  background: #F4F7F9 !important;\n}\n\n/* ------------------------------------------------------------------ */\n/* Dashboard page                                                      */\n/* ------------------------------------------------------------------ */\n\n.emr-dash {\n  max-width: none;\n  margin: 0;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.emr-dash__workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  min-width: 0;\n}\n\n.emr-dash__top {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-items: start;\n  min-width: 0;\n}\n\n.emr-dash__top-side {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-content: start;\n  min-width: 0;\n}\n\n.emr-dash__lower {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-items: start;\n  min-width: 0;\n}\n\n.emr-dash .card.emr-dash__section {\n  margin: 0;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  box-shadow: none;\n}\n\n.emr-dash .emr-dash__section > .card-content {\n  padding: 8px 12px !important;\n}\n\n/* Signature 3px blue right edge on individual Dashboard cards only. */\n.emr-dash .card.emr-dash__section:not(.emr-dash__quick-mod),\n.emr-dash .card.emr-dash-module,\n.emr-dash a.emr-dash-module,\n.emr-dash button.emr-dash-module {\n  border-right: 3px solid var(--emr-primary) !important;\n  box-sizing: border-box;\n}\n\n.emr-dash__mod-title {\n  margin: 0 0 4px;\n  font-size: var(--emr-type-metadata) !important;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-text-secondary);\n  line-height: 1.2;\n}\n\n.emr-dash__pagehead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.emr-mz-dashboard .emr-dash__title,\n.emr-dash__title {\n  margin: 0;\n  font-size: var(--emr-type-page-title) !important;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--emr-text);\n}\n\n.emr-dash__subtitle {\n  margin: 4px 0 0;\n  font-size: var(--emr-type-helper);\n  font-weight: 400;\n  color: var(--emr-text-secondary);\n}\n\n.emr-dash__date {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--emr-border);\n  background: var(--emr-surface);\n  color: var(--emr-text);\n  font-size: var(--emr-type-label);\n  font-weight: 500;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.emr-dash__date-input {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  cursor: pointer;\n  border: 0;\n  background: transparent;\n}\n\n.emr-dash__date:focus-within {\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18);\n  border-color: var(--emr-primary);\n}\n\n.emr-dash__welcome {\n  background: var(--emr-surface) !important;\n  border: 1px solid var(--emr-border) !important;\n  border-right: 3px solid var(--emr-primary) !important;\n  margin-bottom: 0;\n}\n\n.emr-dash__welcome .card-content {\n  padding: 8px 12px !important;\n}\n\n.emr-dash__welcome-body {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px 16px;\n  min-width: 0;\n}\n\n.emr-dash__welcome-copy {\n  min-width: 0;\n  flex: 1 1 200px;\n}\n\n.emr-dash__kicker {\n  margin: 0;\n  font-size: var(--emr-type-metadata);\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--emr-primary);\n}\n\n.emr-mz-dashboard .emr-dash__name,\n.emr-dash__name {\n  margin: 2px 0 0;\n  font-size: var(--emr-type-section-title) !important;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--emr-text);\n}\n\n.emr-dash__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 8px;\n  margin-top: 4px;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-text-secondary);\n}\n\n.emr-dash__role {\n  display: inline-flex;\n  align-items: center;\n  height: 18px;\n  padding: 0 6px;\n  background: #d6e9fa;\n  color: var(--emr-primary-dark);\n  font-size: var(--emr-type-metadata);\n  font-weight: 600;\n}\n\n.emr-dash__orgrow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 14px;\n  margin-top: 6px;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-text);\n}\n\n.emr-dash__orgrow span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.emr-dash__welcome-aside {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 2px;\n  min-height: 0;\n  text-align: right;\n  flex: 0 1 150px;\n}\n\n.emr-dash__pulse {\n  width: 96px;\n  height: 28px;\n  display: block;\n}\n\n.emr-dash__quote {\n  margin: 0;\n  max-width: 160px;\n  font-size: var(--emr-type-metadata);\n  font-style: italic;\n  color: var(--emr-primary-dark);\n  line-height: 1.3;\n}\n\n.emr-mz-dashboard .emr-dash__section-title,\n.emr-dash__section-title {\n  margin: 0 0 4px;\n  font-size: var(--emr-type-section-title) !important;\n  font-weight: 600;\n  color: var(--emr-text);\n}\n\n.emr-dash__section-help {\n  margin: 0 0 6px;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-text-secondary);\n}\n\n.emr-dash-quick {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  align-items: stretch;\n  min-width: 0;\n}\n\n.emr-dash-quick > .emr-dash-module,\n.emr-dash-quick > a.emr-dash-module,\n.emr-dash-quick > button.emr-dash-module {\n  margin: 0 !important;\n  min-width: 0;\n  width: 100%;\n}\n\n@media only screen and (min-width: 600px) {\n  .emr-dash-quick {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .emr-dash__top-side {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n\n@media only screen and (min-width: 1024px) {\n  .emr-dash__top {\n    grid-template-columns: minmax(0, 1.45fr) minmax(210px, 1fr) minmax(210px, 1fr);\n    align-items: stretch;\n  }\n\n  .emr-dash__top-side {\n    display: contents;\n  }\n\n  .emr-dash__welcome-body {\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 8px 16px;\n  }\n\n  .emr-dash__lower {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    align-items: start;\n  }\n\n  .emr-dash-quick {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media only screen and (min-width: 1280px) {\n  .emr-dash-quick {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\nbutton.emr-dash-module {\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n  background: var(--emr-surface);\n}\n\n.emr-dash-module:focus-visible,\n.emr-dash__date:focus-within,\n.emr-mz-dashboard .emr-mz-nav-item:focus-visible,\n.emr-mz-dashboard .emr-mz-userchip:focus-visible,\n.emr-mz-dashboard .emr-mz-icon-btn:focus-visible,\n.emr-mz-dashboard .emr-mz-global-search:focus-visible {\n  outline: 2px solid var(--emr-primary);\n  outline-offset: 2px;\n}\n\n.emr-dash-module {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  min-height: 100%;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n}\n\n.emr-dash-module:hover {\n  border-top-color: var(--emr-primary-light);\n  border-left-color: var(--emr-primary-light);\n  border-bottom-color: var(--emr-primary-light);\n  border-right-color: var(--emr-primary);\n}\n\n.emr-dash-module:focus {\n  outline: none;\n}\n\n.emr-dash-module .card-content {\n  display: grid;\n  grid-template-columns: 24px minmax(0, 1fr);\n  grid-template-areas:\n    \"icon title\"\n    \"icon desc\"\n    \"icon action\";\n  column-gap: 10px;\n  row-gap: 2px;\n  align-content: start;\n  flex: 0 0 auto;\n  padding: 8px 10px !important;\n}\n\n.emr-dash-module__icon {\n  grid-area: icon;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e3f2fd;\n  color: var(--emr-primary);\n  margin-bottom: 0;\n  align-self: start;\n}\n\n.emr-dash-module .card-title {\n  grid-area: title;\n  font-size: var(--emr-type-card-title) !important;\n  font-weight: 600 !important;\n  line-height: 1.25;\n}\n\n.emr-dash-module p {\n  grid-area: desc;\n  margin: 0;\n  flex: none;\n  font-size: var(--emr-type-helper);\n  line-height: 1.35;\n  color: var(--emr-text-secondary);\n}\n\n.emr-dash-module__action {\n  grid-area: action;\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  color: var(--emr-primary);\n  margin-top: 2px;\n}\n\n.emr-dash-panel .card-content {\n  padding: 8px 12px !important;\n}\n\n.emr-dash-panel__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.emr-dash-panel__icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e3f2fd;\n  color: var(--emr-primary);\n}\n\n.emr-dash-panel__list a,\n.emr-dash-panel__list .emr-dash-panel__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 28px;\n  padding: 2px 0;\n  font-size: var(--emr-type-body);\n  color: var(--emr-text);\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.emr-dash-panel__list a:hover {\n  color: var(--emr-primary);\n}\n\n.emr-dash-panel__list a:last-child,\n.emr-dash-panel__list .emr-dash-panel__row:last-child {\n  border-bottom: 0;\n}\n\n.emr-dash-panel__avail {\n  font-size: var(--emr-type-helper);\n  font-weight: 600;\n  color: var(--emr-primary);\n}\n\n.emr-dash-planned {\n  border: 1px solid #eeeeee;\n  background: #fafafa;\n  padding: 6px 10px;\n  margin-bottom: 6px;\n}\n\n.emr-dash-planned__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n}\n\n.emr-dash-planned p {\n  margin: 4px 0 0;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-text-secondary);\n}\n\n.emr-dash-glance__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 28px;\n  padding: 2px 0;\n  border-bottom: 1px solid #f0f0f0;\n  color: var(--emr-text);\n}\n\n.emr-dash-glance__row:last-child {\n  border-bottom: 0;\n}\n\n.emr-dash-glance__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: var(--emr-type-body);\n}\n\n.emr-dash-glance__icon {\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.emr-dash-glance__icon--patients {\n  background: #e3f2fd;\n  color: var(--emr-primary);\n}\n.emr-dash-glance__icon--encounters {\n  background: #e8f5e9;\n  color: var(--emr-success);\n}\n.emr-dash-glance__icon--worklists {\n  background: #f3e5f5;\n  color: #7b1fa2;\n}\n.emr-dash-glance__icon--alerts {\n  background: #ffebee;\n  color: var(--emr-error);\n}\n\n.emr-dash-glance__value {\n  font-size: var(--emr-type-section-title);\n  font-weight: 600;\n  color: var(--emr-text);\n  white-space: nowrap;\n}\n\n.emr-dash-glance__value.is-empty {\n  color: #9e9e9e;\n}\n\n.emr-dash-activity-wrap {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.emr-mz-dashboard table.emr-dash-activity,\n.emr-dash-activity {\n  display: table;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  border-collapse: collapse;\n  position: static;\n}\n\n.emr-mz-dashboard table.emr-dash-activity thead,\n.emr-mz-dashboard table.emr-dash-activity tbody {\n  display: table-header-group;\n  float: none;\n  width: auto;\n  position: static;\n  overflow: visible;\n  white-space: normal;\n}\n\n.emr-mz-dashboard table.emr-dash-activity tbody {\n  display: table-row-group;\n}\n\n.emr-dash-activity th {\n  font-size: var(--emr-type-table-head);\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-text-secondary);\n  padding: 2px 8px 4px 0;\n}\n\n.emr-dash-activity td {\n  font-size: var(--emr-type-table);\n  padding: 6px 8px 6px 0;\n  color: var(--emr-text-secondary);\n}\n\n.emr-dash-empty {\n  text-align: center;\n  color: var(--emr-text-secondary);\n}\n\n.emr-dash__footer.card-panel {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 8px;\n  margin-bottom: 0;\n  padding: 10px 12px;\n  font-size: var(--emr-type-metadata);\n  color: var(--emr-text-secondary);\n}\n\n.emr-dash__footer-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-mz-dashboard .btn.emr-dash-btn-block {\n  display: block;\n  width: 100%;\n  text-align: center;\n  margin-top: 6px;\n  height: 32px;\n  line-height: 32px;\n  padding: 0 12px;\n}\n\n.emr-mz-dashboard .btn-flat.emr-dash-btn-block {\n  border: 1px solid #bbdefb;\n  color: var(--emr-primary-dark);\n}\n\n.emr-mz-dashboard .btn-flat.emr-dash-btn-block:hover {\n  background: #e3f2fd;\n}\n\n@media only screen and (max-width: 992px) {\n  .emr-dash__welcome-aside {\n    align-items: flex-start;\n    text-align: left;\n  }\n\n  .emr-mz-dashboard .emr-mz-main {\n    padding: 12px 16px 16px !important;\n  }\n\n  .emr-mz-dashboard .emr-mz-header__inner {\n    padding: 8px 16px !important;\n  }\n\n  .emr-dash-glance {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 8px;\n  }\n\n  .emr-dash-glance__row {\n    min-width: 0;\n    padding: 3px 4px;\n  }\n\n  .emr-dash-glance__label {\n    min-width: 0;\n  }\n\n  .emr-dash-glance__value {\n    flex-shrink: 0;\n  }\n\n  .emr-dash__footer.card-panel {\n    padding: 10px 12px;\n  }\n}\n\n/* Large phone (~430px): 2-column Quick Access if cards stay readable. */\n@media only screen and (min-width: 400px) and (max-width: 600px) {\n  .emr-dash-quick {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .emr-mz-dashboard {\n    font-size: var(--emr-type-body);\n  }\n\n  .emr-mz-dashboard .emr-mz-header__inner {\n    padding: 8px 12px !important;\n    gap: 8px;\n  }\n\n  .emr-mz-dashboard .emr-mz-main {\n    padding: 12px !important;\n  }\n\n  .emr-mz-dashboard .emr-dash__title,\n  .emr-dash__title {\n    font-size: var(--emr-type-page-title-compact) !important;\n  }\n\n  .emr-mz-dashboard .row .col {\n    padding: 0 6px;\n  }\n\n  .emr-mz-dashboard .card .card-content,\n  .emr-dash-panel .card-content {\n    padding: 8px 10px !important;\n  }\n\n  .emr-dash-module .card-content {\n    padding: 8px 10px !important;\n  }\n\n  .emr-dash-module {\n    height: auto;\n    min-height: 0;\n  }\n\n  .emr-dash__pagehead {\n    margin-bottom: 10px;\n    gap: 8px;\n  }\n\n  .emr-dash__date {\n    flex-shrink: 0;\n    padding: 0 8px;\n    font-size: var(--emr-type-helper);\n  }\n\n  .emr-dash__name,\n  .emr-dash__meta,\n  .emr-dash__orgrow {\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n\n  .emr-dash-module__icon,\n  .emr-dash-panel__icon {\n    width: 24px;\n    height: 24px;\n  }\n\n  .emr-mz-dashboard .emr-mz-global-search::placeholder {\n    font-size: var(--emr-type-label);\n  }\n}\n\n@media only screen and (max-width: 899px) {\n  .emr-mz-dashboard .emr-mz-userchip__chevron {\n    display: none !important;\n  }\n}\n\n/* iPhone-width header: search is a full-width rectangle under compact controls. */\n@media only screen and (max-width: 430px) {\n  .emr-mz-dashboard .emr-mz-header__inner {\n    flex-wrap: wrap;\n    padding: 8px 12px 10px !important;\n  }\n\n  .emr-mz-dashboard .emr-mz-searchform {\n    order: 5;\n    flex: 1 1 100%;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .emr-mz-dashboard .emr-mz-global-search {\n    width: 100% !important;\n  }\n\n  .emr-dash__pagehead {\n    flex-wrap: wrap;\n    align-items: flex-start;\n  }\n\n  .emr-dash__date {\n    margin-top: 2px;\n  }\n\n  .emr-dash-glance__label {\n    font-size: var(--emr-type-label);\n    gap: 6px;\n  }\n}\n\n/* Small phone: prefer a single Quick Access / glance column. */\n@media only screen and (max-width: 399px) {\n  .emr-mz-dashboard .emr-dash-quick > .col.s12 {\n    width: 100% !important;\n  }\n\n  .emr-dash-glance {\n    grid-template-columns: 1fr;\n  }\n\n  .emr-dash__date span {\n    max-width: 9.5rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n/* ------------------------------------------------------------------ */\n/* Patients list — same tokens as Dashboard, page-specific layout only */\n/* ------------------------------------------------------------------ */\n\n.emr-pat {\n  max-width: none;\n  margin: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.emr-pat__pagehead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.emr-mz-dashboard .emr-pat__title,\n.emr-pat__title {\n  margin: 0;\n  font-size: var(--emr-type-page-title) !important;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--emr-text);\n}\n\n.emr-pat__subtitle {\n  margin: 2px 0 0;\n  font-size: var(--emr-type-helper);\n  font-weight: 400;\n  color: var(--emr-text-secondary);\n}\n\n.emr-mz-dashboard .btn.emr-pat__register {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: var(--emr-control-height);\n  padding: 0 14px;\n  margin: 0;\n  flex-shrink: 0;\n  background: var(--emr-primary);\n  border-radius: 0;\n}\n\n.emr-mz-dashboard .btn.emr-pat__register:hover,\n.emr-mz-dashboard .btn.emr-pat__register:focus {\n  background: var(--emr-primary-dark);\n}\n\n.emr-pat__register-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.emr-pat__search {\n  position: relative;\n  max-width: 420px;\n  width: 100%;\n  min-width: 0;\n  margin-bottom: 6px;\n}\n\n.emr-pat__search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  width: 16px;\n  height: 16px;\n  transform: translateY(-50%);\n  color: var(--emr-text-secondary);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.emr-mz-dashboard .emr-pat__search-input,\n.emr-pat__search-input {\n  height: var(--emr-input-height) !important;\n  min-height: var(--emr-input-height) !important;\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box !important;\n  padding-left: 36px !important;\n  padding-right: 12px !important;\n  border: 1px solid var(--emr-border) !important;\n  border-radius: 0 !important;\n  background: var(--emr-surface) !important;\n  box-shadow: none !important;\n  font-size: var(--emr-type-body) !important;\n  font-weight: 400 !important;\n}\n\n.emr-mz-dashboard .emr-pat__search-input:focus {\n  border: 1px solid var(--emr-primary) !important;\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.18) !important;\n  outline: none;\n}\n\n.emr-pat__panel {\n  margin-bottom: 0;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.emr-pat__status,\n.emr-pat__empty {\n  padding: 28px 16px;\n  text-align: center;\n  font-size: var(--emr-type-body);\n  color: var(--emr-text-secondary);\n}\n\n.emr-pat__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-pat__empty-icon {\n  width: 32px;\n  height: 32px;\n  color: #bdbdbd;\n}\n\n.emr-pat__table-wrap {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Keep a real table (not Materialize's split-header responsive-table) so\n   phones scroll inside this wrapper instead of fracturing the page. */\n.emr-mz-dashboard table.emr-pat__table,\n.emr-pat__table {\n  display: table;\n  width: 100%;\n  min-width: 720px;\n  border-collapse: collapse;\n  position: static;\n}\n\n.emr-mz-dashboard table.emr-pat__table thead,\n.emr-mz-dashboard table.emr-pat__table tbody {\n  display: table-header-group;\n  position: static;\n  float: none;\n  overflow: visible;\n  width: auto;\n}\n\n.emr-mz-dashboard table.emr-pat__table tbody {\n  display: table-row-group;\n}\n\n.emr-mz-dashboard table.emr-pat__table tr {\n  display: table-row;\n}\n\n.emr-mz-dashboard table.emr-pat__table th,\n.emr-mz-dashboard table.emr-pat__table td {\n  display: table-cell;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  line-height: 1.25;\n}\n\n.emr-mz-dashboard .emr-pat__table th {\n  font-size: var(--emr-type-table-head);\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--emr-text-secondary);\n  padding: 4px 12px;\n  line-height: 1.25;\n  border-bottom: 1px solid var(--emr-border);\n  background: #fafbfc;\n  white-space: nowrap;\n}\n\n.emr-mz-dashboard .emr-pat__table td {\n  font-size: var(--emr-type-table);\n  font-weight: 400;\n  padding: 4px 12px;\n  line-height: var(--emr-leading-compact);\n  color: var(--emr-text);\n  border-bottom: 1px solid #f0f0f0;\n  vertical-align: middle;\n}\n\n.emr-pat__actions-col {\n  text-align: right;\n}\n\n.emr-pat__mrn {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  background: #0b1f33;\n  color: #90caf9;\n  font-size: var(--emr-type-metadata);\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-decoration: none;\n  border-radius: 0;\n}\n\n.emr-pat__mrn:hover {\n  background: var(--emr-primary-dark);\n  color: #fff;\n}\n\n.emr-pat__name {\n  font-size: var(--emr-type-table);\n  font-weight: 600;\n  color: var(--emr-text);\n  text-decoration: none;\n}\n\n.emr-pat__name:hover {\n  color: var(--emr-primary);\n  text-decoration: underline;\n}\n\n.emr-pat__demo {\n  display: inline-flex;\n  align-items: center;\n  height: 18px;\n  margin-left: 8px;\n  padding: 0 6px;\n  background: #fff8e1;\n  color: #f9a825;\n  font-size: var(--emr-type-micro);\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  vertical-align: middle;\n  border-radius: 0;\n}\n\n.emr-pat__row-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 2px;\n}\n\n.emr-mz-dashboard .emr-pat-icon-btn {\n  width: 24px !important;\n  height: 24px !important;\n  min-width: 24px !important;\n  min-height: 24px !important;\n  padding: 0 !important;\n  line-height: 1 !important;\n  border-radius: 0 !important;\n  color: var(--emr-primary);\n}\n\n.emr-mz-dashboard .emr-pat-icon-btn--danger {\n  color: var(--emr-error);\n}\n\n.emr-pat-form,\n.emr-pat-dialog {\n  border-radius: 0 !important;\n  border: 1px solid var(--emr-border, #e0e0e0);\n  background: #fff !important;\n  box-shadow: none;\n}\n\n.emr-pat-form [data-radix-collection-item],\n.emr-pat-form [role=\"tab\"] {\n  border-radius: 0 !important;\n  font-size: var(--emr-type-button);\n  font-weight: 600;\n}\n\n.emr-mz-dashboard .emr-pat-form__save,\n.emr-pat-form .emr-pat-form__save {\n  background: #1976d2 !important;\n  border-radius: 0 !important;\n  font-size: var(--emr-type-button);\n  font-weight: 600;\n}\n\n.emr-mz-dashboard .emr-pat-form__save:hover,\n.emr-pat-form .emr-pat-form__save:hover {\n  background: #0d47a1 !important;\n}\n\n.emr-pat-dialog__delete {\n  background: #d32f2f !important;\n  border-radius: 0 !important;\n}\n\n@media only screen and (max-width: 899px) {\n  .emr-pat__pagehead {\n    flex-wrap: wrap;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .emr-pat__pagehead {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n    margin-bottom: 6px;\n  }\n\n  .emr-mz-dashboard .emr-pat__title,\n  .emr-pat__title {\n    font-size: var(--emr-type-page-title-compact) !important;\n  }\n\n  .emr-mz-dashboard .btn.emr-pat__register {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .emr-pat__search {\n    max-width: 100%;\n  }\n\n  .emr-mz-dashboard .emr-pat__table th,\n  .emr-mz-dashboard .emr-pat__table td {\n    padding: 4px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
